import { Component, OnDestroy, OnInit } from '@angular/core';
import { filter, take, takeUntil } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { RoutesConst } from '@carm/shared/constants/const-routes';
import { CarmRouter } from '@carm/_core/carm-router/services/carm-router.service';
import { AccessUserService } from '@carm/_core/access-control-mgt/services';
import { RolePermissionLoadingService } from '@carm/_core/role-type-permissions/services';
import { PublicHeaderService } from '@carm/base-layout/main/public-header.service';
import { Router } from '@angular/router';
import { BaseComponent } from '@carm/_utils/base.component';
import { AuthService } from '@carm/_auth/spartacus/core/auth';

@Component({
  selector: 'carm-not-found',
  templateUrl: './not-found.component.html'
})
export class NotFoundComponent extends BaseComponent implements OnInit, OnDestroy {
  public isLoggedIn$: Observable<boolean>;
  public hasRole = false;
  private bn9: string;
  private programAccountNumber: string;
  public isOrphan = true;
  public firstTimeSetupRoute: boolean;

  constructor(private authService: AuthService,
              private accessUserService: AccessUserService,
              private router: Router,
              private carmRouter: CarmRouter,
              private rolePermissionLoadingService: RolePermissionLoadingService,
              private publicHeaderService: PublicHeaderService) {
    super();
  }


  ngOnInit(): void {
    if (this.router.url.indexOf('/first-time-setup') > -1) {
      this.firstTimeSetupRoute = true;
    }

    this.isLoggedIn$ = this.authService.isUserLoggedIn().pipe(takeUntil(this.destroy$));
      this.accessUserService.getUserRoles()
        .pipe(
          filter((roleData) => roleData.role !== null &&
            roleData.role.lastUsedRole !== null &&
            roleData.role.roles?.length > 0),
          take(1),
        ).subscribe((r) => {

        this.programAccountNumber =  r.role?.lastUsedRole?.program?.uid;
        this.bn9 = r.role?.lastUsedRole?.program?.companyUid;
        this.hasRole = r.role.roles?.length > 0;

        this.isOrphan = !this.bn9;

        this.rolePermissionLoadingService.getPermissions(r.role.lastUsedRole.program.uid).pipe(
          take(1),
          takeUntil(this.destroy$)
        ).subscribe(_permissions => {
          this.publicHeaderService.showProgramToggler.next(true);
        });

      }, (_) => {});
  }

  navigateToHomepage(){
    this.carmRouter.carmNavigate([RoutesConst.PublicHome]);
  }

  navigateToDashboard(){
    this.carmRouter.carmNavigateByCustomBusinessNumbers(this.bn9, this.programAccountNumber, [RoutesConst.Dashboard]);
  }

  navigateToRegistrationDashboard(){
    this.carmRouter.carmNavigate([RoutesConst.PortalRegistrationStatus]);
  }

  navigateToFirstSetup(){
    this.carmRouter.carmNavigate([RoutesConst.AccountProfile_FirstTimeSetup]);
  }
}
